import { render, staticRenderFns } from "./ModalCreateNewCorporatePlan.vue?vue&type=template&id=5521d6b0&scoped=true&"
import script from "./ModalCreateNewCorporatePlan.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewCorporatePlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateNewCorporatePlan.vue?vue&type=style&index=0&id=5521d6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521d6b0",
  null
  
)

export default component.exports